export default "__VITE_ASSET__BH7JxGZI__"